import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import "./AwsCredentials.scss"


export function AwsCredentials({awsCredentials}) {
  if (!awsCredentials.method) {
    return <></>
  }

  return (
    <div className="aws-credentials">
      {awsCredentials.method === "role" ?
        <table>
          <tbody>
            <tr>
              <td>Cloud: </td>
              <td>Amazon Web Services</td>
            </tr>
            <tr>
              <td>Region: </td>
              <td>{awsCredentials.region}</td>
            </tr>
            {/* <tr>
              <td>Role ARN: </td>
              <td>{awsCredentials.roleArn}</td>
            </tr>
            <tr>
              <td>External ID: </td>
              <td>{awsCredentials.externalId}</td>
            </tr> */}
            <tr>
              <td>Account: </td>
              <td>{awsCredentials.accountName}</td>
            </tr>
          </tbody>
        </table>
        :
        <table>
          <tbody>
            <tr>
              <td>Cloud: </td>
              <td>Amazon Web Services</td>
            </tr>
            <tr>
              <td>Region: </td>
              <td>{awsCredentials.region}</td>
            </tr>
            {/* <tr>
              <td>Key: </td>
              <td>{awsCredentials.accessKey}</td>
            </tr> */}
            <tr>
              <td>Account: </td>
              <td>{awsCredentials.accountName}</td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  )
}



AwsCredentials.propTypes = {
  awsCredentials: PropTypes.shape({
    secretAccessKey: PropTypes.string,
    region: PropTypes.string,
    accessKey: PropTypes.string,
    method: PropTypes.string,
    roleArn: PropTypes.string,
    externalId: PropTypes.string,
    awsaccount: PropTypes.string,
  })
}


const mapStateToProps = state => ({
  awsCredentials: state.awsCredentials
})


export default connect(mapStateToProps)(AwsCredentials)
